import { useState } from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

import { useLoginMutation, useSignUpMutation } from "generated/graphql";
import AuthHeader from "components/auth/AuthHeader";
// import AuthFooter from "components/auth/AuthFooter";
import { submitRegistrationForm } from "./functions";
import InputField, {
  MultiSelectField,
  SelectField,
} from "components/auth/InputField";
import { AuthFormWrapper, Error } from "components/auth/shared";
import dayjs from "dayjs";

const RegistrationForm = styled.form``;

function RegistrationPage() {
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [nickname, setNickname] = useState("");
  const [email, setEmail] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [preferredGames, setPreferredGames] = useState<
    { [key: string]: string }[] | string
  >("");
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const [acknowledged, setAcknowledged] = useState(false);

  const [signUpMutation, { loading, error: signupErr }] = useSignUpMutation();
  const [loginMutation, { loading: loggingIn }] = useLoginMutation();

  return (
    <>
      <AuthHeader />
      <AuthFormWrapper>
        <h1>Sign Up to Jiwe eSports</h1>
        <p>
          Already a member? <Link to="/auth/login">Log In</Link>
        </p>
        {(signupErr || errMsg) && (
          <Error>
            {signupErr?.message}
            {errMsg}
          </Error>
        )}
        <RegistrationForm
          onSubmit={(e) => {
            e.preventDefault();
            const age = dayjs().diff(dayjs(dateOfBirth), "year");
            if (age < 18) {
              setErrMsg("You need to be 18 and over to register");
              return;
            }
            submitRegistrationForm({
              acknowledged,
              dateOfBirth,
              // @ts-ignore
              gender: gender.value,
              setErrMsg,
              signUpMutation,
              loginMutation,
              email,
              password,
              phoneNumber,
              preferredGames,
              name,
              nickname,
            });
          }}
        >
          <InputField
            setValue={setName}
            value={name}
            placeholder="John Rambo"
            type="text"
            name="name"
            label="Name"
            className="input-box"
          />
          <InputField
            setValue={setDateOfBirth}
            value={dateOfBirth}
            placeholder="Date of birth"
            type="date"
            name="dob"
            label="Date of birth"
            className="input-box"
            onBlur={() => {
              const age = dayjs().diff(dayjs(dateOfBirth), "year");
              if (age < 18) {
                setErrMsg("You need to be over 18 to register");
              }
            }}
          />
          <SelectField
            setValue={setGender}
            value={gender}
            placeholder="Gender"
            type="text"
            name="gender"
            label="Gender"
            options={[
              { label: "Female", value: "female" },
              { label: "Male", value: "male" },
            ]}
          />
          <InputField
            setValue={setNickname}
            value={nickname}
            placeholder="Your display name"
            type="text"
            name="nickname"
            label="Display name"
            className="input-box"
          />
          <InputField
            setValue={setEmail}
            value={email}
            placeholder="name@email.com"
            type="email"
            name="email"
            label="Email"
            className="input-box"
          />
          <InputField
            setValue={setPhoneNumber}
            value={phoneNumber}
            placeholder="+254700123456"
            type="text"
            name="phoneNumber"
            label="Phone Number"
            className="input-box"
          />
          <InputField
            setValue={setPassword}
            value={password}
            placeholder="6+ Characters"
            type="password"
            name="password"
            label="Password"
            className="input-box"
          />
          <MultiSelectField
            setValue={(value: any, action: any) => setPreferredGames(value)}
            // @ts-ignore
            value={preferredGames}
            placeholder="Preferred Game"
            type="text"
            name="preferred_game"
            label="Preferred Game"
            options={[
              { label: "Call of Duty Mobile", value: "Call of Duty Mobile" },
              { label: "Call of Duty Warzone", value: "Call of Duty Warzone" },
              { label: "PUBG", value: "PUBG" },
              { label: "Tekken", value: "Tekken" },
              { label: "Mortal Kombat", value: "Mortal Kombat" },
              { label: "FIFA", value: "FIFA" },
              { label: "FreeFire", value: "FreeFire" },
              { label: "Fortnite", value: "Fortnite" },
            ]}
          />
          <p className="terms">
            <span>
              <input
                type="checkbox"
                onChange={(event) => setAcknowledged(!acknowledged)}
                checked={acknowledged}
              />
            </span>
            I accept the Terms of Use and I acknowledge having read the privacy
            and cookies policy
          </p>
          <button type="submit" className="btn" disabled={loading || loggingIn}>
            Create an account
          </button>
          <br />
          {/* <AuthFooter
            loading={loading}
            loggingIn={loggingIn}
            buttonText="Sign Up with Google"
          /> */}
        </RegistrationForm>
      </AuthFormWrapper>
    </>
  );
}

export default RegistrationPage;
